import axios from 'axios';
import axiosInstance from 'api/axiosInstance';

// 타입 정의
interface YmydUserResponse {
  message: string;
  data: {
    id: number;
    email: string;
    name: string;
    nickname: string;
    phone: string;
    profileUrl?: string;
    workPlaceName?: string;
    workPlaceAddress?: string;
    workPlaceRegion?: string;
    workPlacePhone?: string;
    level: number;
    premiumType: number;
    license?: string;
    workType?: number;
    // 기타 필드들
  };
  error: number;
}

interface YmydLoginResponse {
  message: string;
  data: {
    token: string;
  };
  error: number;
}

// YMYD API 클라이언트 설정
const YMYD_API_BASE_URL = process.env.REACT_APP_YMYD_BACKEND_URL || 'https://api.rel.ymyd.onjourney.co.kr';

const ymydApiClient = axios.create({
  baseURL: `${YMYD_API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// CORS 에러 발생 시 아래 주석 해제하고 setupProxy.js 활성화
// const ymydApiClient = axios.create({
//   baseURL: '/ymyd-api',
//   headers: {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json'
//   }
// });

export const ymydApi = {
  // 카카오 ID로 약문약답 로그인
  loginWithKakao: async (kakaoId: string): Promise<YmydLoginResponse> => {
    const response = await ymydApiClient.post('/user/auth/sns', { kakaoId });
    return response.data;
  },
  
  // 사용자 정보 조회
  getUserInfo: async (token: string): Promise<YmydUserResponse> => {
    const response = await ymydApiClient.get('/user/me', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

// PRAI API - 기존 API 사용
export const praiApi = {
  // 중복 가입 체크
  checkUserExists: async (email: string) => {
    try {
      const response = await axiosInstance.post('/api/v1/users/check', { email });
      return response.data;
    } catch (error) {
      return { exists: false };
    }
  },
  
  // 회원가입
  signup: async (userData: {
    email: string;
    password: string;
    name: string;
    phone?: string;
    company?: string;
    ymydId?: number;
    license?: string;
  }) => {
    const response = await axiosInstance.post('/api/v1/auth/signup', userData);
    return response.data;
  }
};

// 약문약답 사용자 정보를 PRAI User로 변환
export const mapYmydUserToPraiUser = (ymydUser: YmydUserResponse['data']) => {
  return {
    email: ymydUser.email,
    name: ymydUser.name,
    phone: ymydUser.phone,
    license: ymydUser.license,
    company: ymydUser.workPlaceRegion, // 근무지역을 company에 저장
    ymydId: ymydUser.id,
  };
};